import DataSourceConfig from '../Config/DataSourceConfig';
import SystemDataService from '../Services/SystemDataService';

// --- 1. THE INDUSTRIAL REGISTRY ---
const CategoryData = {
    en: {
        categories: [
            /* --- PRIMARY PARENT HUB --- */
            {
                id: 'garage-doors',
                parentId: null,
                slug: 'garage-doors',
                status: true,
                media: "https://sawpy-assets.s3.us-east-2.amazonaws.com/BH-Hardware/gallery/1774116654621.mp4",
                name: 'Garage Doors',
                title: 'Garage Door Parts',
                subtitle: 'Complete Industrial & Residential Assemblies',
                description: 'High-velocity sourcing for complete garage door systems.',
                image: "/placeholder.svg",
                promo: null,
                ctaText: 'Shop Garage Doors',
                paragraph: 'The BH-Hardware Garage Door registry provides access to full system assemblies. Engineered for structural integrity and high-frequency operation, our systems are the standard for professional installers nationwide.',
                seo: {
                    title: 'Garage Door Systems | BH-Hardware Wholesale',
                    description: 'Wholesale full garage door systems for residential and commercial use. Industrial-grade assemblies and fast dispatch.',
                    keywords: 'garage doors, full door systems, industrial garage doors, wholesale doors'
                },
                faq: [
                    { question: "Do you ship full door sections?", answer: "Yes, we provide full section logistics for verified professional accounts via LTL freight." },
                    { question: "Are these doors wind-load rated?", answer: "We offer configurations engineered to meet localized wind-load requirements, including Florida's HVHZ standards." },
                    { question: "Do sections come pre-punched for hinges?", answer: "Our industrial-grade sections are often pre-punched to ensure precise alignment and high-velocity installation." },
                    { question: "Can I order custom-sized full doors?", answer: "Yes, custom dimensions for non-standard commercial or residential openings are available through our registry." },
                    { question: "What R-values are available for insulated doors?", answer: "We stock multiple insulation tiers, including high-performance injected polyurethane for maximum thermal efficiency." },
                    { question: "Is hardware included with full door orders?", answer: "Standard manifests include tracks, springs, and hinges, but custom hardware can be specified at the point of order." },
                    { question: "What is the lead time for full system dispatch?", answer: "Standard sizes typically dispatch within 3-5 business days; custom systems vary based on technical specs." }
                ]
            },

            /* --- SUB-CATEGORIES (Parent: "garage-doors") --- */
            {
                id: 'torsion-springs',
                parentId: 'garage-doors',
                slug: 'torsion-springs',
                status: true,
                media: "https://sawpy-assets.s3.us-east-2.amazonaws.com/BH-Hardware/gallery/1772991765827.mp4",
                name: 'Torsion Springs',
                title: 'Torsion Springs',
                subtitle: 'Oil-Tempered High-Cycle Rated',
                description: 'Professional-grade lifting springs with verified IPPT data.',
                image: "https://sawpy-assets.s3.us-east-2.amazonaws.com/BH-Hardware/gallery/1774459104456.png",
                promo: null,
                ctaText: 'Shop Torsion Springs',
                paragraph: 'Our heavy-duty, high-tensile garage door springs are manufactured for maximum cycle life. We offer a comprehensive inventory of torsion and extension springs for residential and commercial applications.',
                seo: {
                    title: 'Wholesale Torsion Springs | BH-Hardware',
                    description: 'Shop high-tensile torsion and extension springs. Bulk pricing and fast shipping for garage door professionals.',
                    keywords: 'garage door springs, torsion springs, extension springs, wholesale garage parts'
                },
                faq: [
                    { question: "Do you offer bulk discounts on springs?", answer: "Yes, we offer tiered bulk pricing for verified B2B installers and wholesale partners." },
                    { question: "What is the cycle rating on your torsion springs?", answer: "Standard units are rated for 10,000 to 15,000 cycles, with high-cycle variants reaching 50,000 cycles available." },
                    { question: "Can I order springs by IPPT data?", answer: "Absolutely. Our registry allows for precision sourcing based on Inches Per Pound Turn (IPPT) to ensure zero-defect balance." },
                    { question: "Are winding and stationary cones pre-installed?", answer: "Most springs in our manifest come with professional-grade cones pre-installed for efficiency." },
                    { question: "Do you provide custom wire diameter winding?", answer: "Yes, we can provide custom windings for specific industrial load requirements." },
                    { question: "What is the difference between oil-tempered and black-coated springs?", answer: "Oil-tempering is the traditional structural standard; coated options offer enhanced cleanliness and corrosion resistance." },
                    { question: "Is the warranty valid for commercial installations?", answer: "Yes, our performance warranty covers both residential and commercial deployments when professionally installed." }
                ]
            },
            {
                id: 'galvanized-torsion-springs',
                parentId: 'garage-doors',
                slug: 'galvanized-torsion-springs',
                status: true,
                media: "https://sawpy-assets.s3.us-east-2.amazonaws.com/BH-Hardware/gallery/1774116582236.mp4",
                name: 'Galvanized Torsion Springs',
                title: 'Galvanized Torsion Springs',
                subtitle: 'Superior Rust Defense for Coastal Environments',
                description: 'Durable galvanized finish for maximum environmental protection.',
                image: "https://sawpy-assets.s3.us-east-2.amazonaws.com/BH-Hardware/gallery/1774459129121.png",
                promo: null,
                ctaText: 'Shop Galvanized Springs',
                paragraph: 'Designed for high-moisture and coastal environments, our galvanized torsion springs offer an extra layer of oxidation protection while maintaining high-tensile structural integrity.',
                seo: {
                    title: 'Galvanized Torsion Springs | BH-Hardware',
                    description: 'Rust-resistant galvanized torsion springs for coastal garage door installations.',
                    keywords: 'galvanized springs, rust resistant torsion, coastal garage hardware'
                },
                faq: [
                    { question: "Do galvanized springs require extra maintenance?", answer: "While the coating provides superior rust resistance, regular lubrication is still recommended for smooth operation." },
                    { question: "Are these springs better for coastal zones?", answer: "Yes, galvanized steel is the industrial standard for coastal properties where salt-air accelerates oxidation." },
                    { question: "Do galvanized springs lose tension faster?", answer: "No, our galvanized units maintain the same high-tensile strength and IPPT reliability as our standard springs." },
                    { question: "Is the finish purely aesthetic?", answer: "No, the finish is a functional zinc-coating that acts as a sacrificial layer against environmental corrosion." },
                    { question: "Can I use galvanized springs on commercial high-lift doors?", answer: "Yes, provided the spring is engineered for the specific door weight and cycle requirements." },
                    { question: "Do you stock both torsion and extension galvanized variants?", answer: "Yes, both types are available with galvanized coatings in our environmental registry." },
                    { question: "What wire gauges are available?", answer: "We stock all standard professional gauges, from .207 to .295, in our galvanized inventory." }
                ]
            },
            {
                id: 'drums-cables',
                parentId: 'garage-doors',
                slug: 'drums-and-cables',
                status: true,
                media: "https://sawpy-assets.s3.us-east-2.amazonaws.com/BH-Hardware/gallery/1773509984215.mp4",
                name: 'Drums and Cables',
                title: 'Drums & Cables',
                subtitle: 'Reliable Lifting Power',
                description: 'High-strength galvanized cables and precision-cast aluminum drums.',
                image: "https://sawpy-assets.s3.us-east-2.amazonaws.com/BH-Hardware/gallery/1774459079864.png",
                promo: { label: 'Save', value: '25% Off', sub: 'Your First Order' },
                ctaText: 'Shop Now',
                paragraph: 'Safety starts with the lifting system. We supply aircraft-grade galvanized cables and precision-cast aluminum drums for a perfectly balanced door.',
                seo: {
                    title: 'Garage Door Cables & Drums | BH-Hardware',
                    description: 'High-strength aircraft cables and precision-cast drums for standard, high-lift, and vertical-lift doors.',
                    keywords: 'garage door cables, standard lift drums, high lift drums, vertical lift drums'
                },
                faq: [
                    { question: "Do you sell cable in bulk spools?", answer: "Yes, we offer cables in pre-cut assemblies or 500ft/1000ft bulk spools." },
                    { question: "What is 'aircraft-grade' cable?", answer: "It refers to high-strength 7x7 or 7x19 galvanized steel wire rope designed for high-tensile lifting." },
                    { question: "Are the drums compatible with standard 1-inch shafts?", answer: "Our standard drums are cast for 1-inch shafts, but we also stock 1.25-inch bore drums for industrial systems." },
                    { question: "Can I use standard drums on a high-lift system?", answer: "No, high-lift systems require specific graduated drums to manage the vertical-to-horizontal transition." },
                    { question: "Are your cable assemblies swaged or clamped?", answer: "Professional assemblies in our manifest are machine-swaged for maximum pull-strength and safety." },
                    { question: "What cable diameter should I use for commercial doors?", answer: "We typically recommend 5/32\" or 3/16\" cables for heavy commercial loads." },
                    { question: "Do the drums come with set screws?", answer: "Yes, all precision-cast drums include high-torque set screws for secure shaft mounting." }
                ]
            },
            {
                id: 'brackets-bearings',
                parentId: 'garage-doors',
                slug: 'brackets-and-bearings',
                status: true,
                media: "https://sawpy-assets.s3.us-east-2.amazonaws.com/BH-Hardware/gallery/1774116450945.mp4",
                name: 'Brackets and Bearing',
                title: 'Brackets & Bearings',
                subtitle: 'Reinforced Structural Support',
                description: 'Heavy-duty bearing plates, center supports, and structural brackets.',
                image: "/placeholder.svg",
                promo: null,
                ctaText: 'Shop Brackets & Bearings',
                paragraph: 'Ensure a stable assembly with our commercial-grade brackets and precision-sealed bearings. Designed to withstand high-torque loads.',
                seo: {
                    title: 'Garage Door Brackets & Bearings | BH-Hardware',
                    description: 'Heavy-duty brackets and precision bearings for garage door installation. Professional structural hardware.',
                    keywords: 'door brackets, bearing plates, center support, garage door bearings'
                },
                faq: [
                    { question: "Are the bearing plates pre-assembled?", answer: "We offer both pre-installed bearing plates and individual components for custom requirements." },
                    { question: "What gauge of steel is used for your brackets?", answer: "Our structural brackets are manufactured from heavy-duty 14-gauge and 11-gauge commercial steel." },
                    { question: "Are the bearings sealed or open?", answer: "We prioritize precision-sealed bearings to prevent debris ingress and ensure a longer cycle life." },
                    { question: "Do you carry universal operator brackets?", answer: "Yes, our operator reinforcement brackets are designed to fit most residential and commercial motors." },
                    { question: "What is the load rating for the end-bearing plates?", answer: "Load ratings vary by gauge; technical data is provided in the product specifications for each SKU." },
                    { question: "Can I order 1.25-inch bearing plates?", answer: "Yes, we stock both 1-inch and 1.25-inch bearing configurations for industrial shafts." },
                    { question: "Are center-bearing plates included in spring kits?", answer: "Center supports can be added to any spring manifest to ensure proper shaft alignment." }
                ]
            },
            {
                id: 'rollers-hinges',
                parentId: 'garage-doors',
                slug: 'rollers-and-hinges',
                status: true,
                media: "https://sawpy-assets.s3.us-east-2.amazonaws.com/BH-Hardware/gallery/1774116434921.mp4",
                name: 'Rollers and Hinges',
                title: 'Rollers & Hinges',
                subtitle: 'Smooth, Quiet, and Built to Last',
                description: 'Professional-grade nylon rollers and commercial steel hinges.',
                image: "/placeholder.svg",
                promo: null,
                ctaText: 'Shop Rollers & Hinges',
                paragraph: 'Eliminate garage door noise and track wear with our precision-sealed nylon rollers. Paired with our heavy-duty 14-gauge steel hinges.',
                seo: {
                    title: 'Garage Door Rollers & Hinges | BH-Hardware',
                    description: 'Wholesale nylon garage door rollers and heavy-duty 14-gauge steel hinges for professional installers.',
                    keywords: 'nylon rollers, garage door hinges, 14 gauge hinges'
                },
                faq: [
                    { question: "What is the difference between 10-ball and 13-ball rollers?", answer: "13-ball rollers distribute weight more evenly, resulting in quieter operation and a longer lifespan." },
                    { question: "Are the hinges made from galvanized steel?", answer: "Our hinges are manufactured from high-grade galvanized steel to resist oxidation and fatigue." },
                    { question: "Do you stock long-stem rollers?", answer: "Yes, 7-inch and 9-inch long-stem rollers are available for specialized applications." },
                    { question: "What is the cycle rating on your nylon rollers?", answer: "Our 13-ball precision nylon rollers are rated for over 50,000 cycles under standard loads." },
                    { question: "Can I use 14-gauge hinges on a commercial door?", answer: "14-gauge is the commercial standard; we also stock 11-gauge hinge manifests for extreme-duty." },
                    { question: "Are the roller stems made of stainless steel?", answer: "Our standard stems are galvanized steel, but stainless options are available for coastal deployments." },
                    { question: "Do you sell hinges in bulk boxes?", answer: "Yes, hinges are available in bulk contractor packs for high-velocity inventory management." }
                ]
            },
            {
                id: 'bars-seals',
                parentId: 'garage-doors',
                slug: 'bars-and-seals',
                status: true,
                media: "https://sawpy-assets.s3.us-east-2.amazonaws.com/BH-Hardware/gallery/1774116457570.mp4",
                name: 'Bars and Seals',
                title: 'Bars & Seals',
                subtitle: 'Protecting Integrity & Efficiency',
                description: 'Bottom seals, retainers, and industrial struts.',
                image: "/placeholder.svg",
                promo: null,
                ctaText: 'Shop Bars & Seals',
                paragraph: 'Keep the elements and debris out while reinforcing the door structure. We carry a massive inventory of bottom seals, high-tensile struts, and perimeter stripping.',
                seo: {
                    title: 'Garage Door Bars & Seals | BH-Hardware',
                    description: 'Wholesale garage door weather seals and reinforcement struts. Shop bottom seals and retainers.',
                    keywords: 'garage door seal, weather stripping, door struts'
                },
                faq: [
                    { question: "What sizes do your bottom seals come in?", answer: "We carry 3-inch, 4-inch, and 6-inch wide bottom seals in rolls up to 100 feet." },
                    { question: "Are the struts made from high-tensile steel?", answer: "Yes, our reinforcement struts are engineered to prevent section sagging and improve wind-load resistance." },
                    { question: "What is the material of the bottom seals?", answer: "We stock both high-flexibility EPDM rubber and durable PVC seals to match different climates." },
                    { question: "Do you sell aluminum retainers for the seals?", answer: "Yes, we have multiple retainer profiles (L-shape, T-shape) available in 8ft to 16ft lengths." },
                    { question: "Can I use these seals for commercial loading docks?", answer: "Absolutely, our heavy-duty 6-inch seals are designed for high-abuse industrial environments." },
                    { question: "Do you carry side and top perimeter seals?", answer: "Yes, we stock color-matched perimeter weather stripping to ensure a complete environmental seal." },
                    { question: "Are the winding bars solid steel?", answer: "Yes, our winding bars are manufactured from solid cold-rolled steel for maximum safety." }
                ]
            }
        ]
    }
};

// --- 2. LOCAL DATA REFERENCE ---
const localCategories = CategoryData.en.categories;

// --- 3. PUBLIC API ---

export const getAllCategories = () => localCategories;

export const getCategoriesData = async () => {
    if (DataSourceConfig.categories === 'local') {
        return localCategories;
    }

    try {
        const apiData = await SystemDataService.getCategories();
        if (apiData && Array.isArray(apiData) && apiData.length > 0) return apiData;
    } catch (err) {
        console.error('getCategoriesData: backend failed, using local data', err);
    }

    return localCategories;
};

export const isValidCategory = (slug) => localCategories.some(c => c.slug === slug);

export default localCategories;